<template>
  <table
    :style="cssVars"
    :class="style.borders ? 'bordered' : ''"
    class="combined-report styled-table selectable"
    v-if="tableValues.length > 0"
  >
    <thead>
      <tr>
        <th style="min-width: 150px" class="header-title"></th>
        <th
          class="header-title"
          v-for="row in tableItems"
          :key="row.id"
          :colspan="row.options.length"
        >
          <span class="" v-text="row.text ? row.text : row.label"></span>
        </th>
      </tr>
      <tr>
        <th class="header-title"></th>
        <th
          :class="item.group % 2 == 0 ? 'even' : 'odd'"
          v-for="item in tablePercentageTotals"
          :key="item.id"
        >
          <div class="rotate-text">
            <span>{{ item.text }}</span>
            <small class="font-weight-regular d-block">{{
              item.parentName
            }}</small>
          </div>
        </th>
      </tr>
    </thead>

    <template v-for="(categ, key) in tableValues">
      <tr :key="key" style="border-top: 1px solid #ccc">
        <td class="categ-title" style="text-align: left; padding: 1px 6px">
          {{ categ.rowTitle }}
        </td>
        <td
          class="categ-title"
          style="padding: 1px 0"
          :colspan="tablePercentageTotals.length"
        ></td>
      </tr>
      <tr
        v-for="(subCateg, index) in categ.rowData"
        :key="'C' + index + subCateg.id + key"
      >
        <td class="subcateg-title" style="text-align: right">
          {{ subCateg.title }}
        </td>
        <td
          :class="value.group % 2 == 0 ? 'even' : 'odd'"
          v-for="(value, i) in subCateg.items"
          :key="i + key"
        >
          {{ value.count }}
        </td>
      </tr>
    </template>
    <tr class="total">
      <td class="categ-title" rowspan="2"><span>Total</span></td>
      <td
        class="total-cell"
        :class="total.group % 2 == 0 ? 'even' : 'odd'"
        v-for="(total, i) in tablePercentageTotals"
        :key="'total' + i"
      >
        {{ total.count }}
      </td>
    </tr>
    <tr class="total">
      <td
        v-for="(total, i) in tablePercentageTotals"
        :class="total.group % 2 == 0 ? 'even' : 'odd'"
        :key="'total' + i"
      >
        <small> {{ total.percentageTotal }}%</small>
      </td>
    </tr>
  </table>
  <div v-else>
    <p>Não tem registos associados a este estágio</p>
  </div>
</template>

<script>
import { Component, Internship } from '../../../../models/Specialty'
import { Anesthesiology } from '../../../../models/Anesthesiology'
import helpers from '../../mixins/statsHelperFunc'
import { AgeOption } from '@/models/Content'
export default {
  props: {
    logs: Array,
    logbookType: String
  },
  mixins: [helpers],
  data() {
    return {
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      tableStructure: [
        { 'anesthesia-regimen': {} },
        { sex: {} },
        { age: {} },
        { asa: {} },
        { 'anesthesia-type': {} },
        { duration: {} }
      ],
      header: 'Internship'
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    components() {
      return this.allStatsComponents(this.logbookType)
    },
    locoRegionalTree() {
      const component =
        Anesthesiology.query().with('locoRegionalTree.*').first() || {}
      return component
    },
    generalAnesthesiaComponent() {
      const component = Component.query()
        .where('id', 'general-anesthesia')
        .withAllRecursive()
        .first()
      return component
    },
    userInternships() {
      const allInternships = Internship.query().get()
      const userFilteredInternships = allInternships.filter(internship =>
        this.logs.some(log => log.internship === internship.id)
      )
      return userFilteredInternships
    },
    tableItems() {
      const tableStructureCopy = JSON.parse(JSON.stringify(this.tableStructure))
      const componentsCopy = JSON.parse(JSON.stringify(this.components))
      const generalAnesthesiaComponentCopy = JSON.parse(
        JSON.stringify(this.generalAnesthesiaComponent)
      )
      const locoRegionalTreeCopy = JSON.parse(
        JSON.stringify(this.locoRegionalTree)
      )
      const userInternships = JSON.parse(JSON.stringify(this.userInternships))

      tableStructureCopy.map((element, index) => {
        const itemKey = Object.keys(element)[0]
        const componentOptions = componentsCopy.filter(
          component => component.id === itemKey
        )
        tableStructureCopy[index] = componentOptions[0]
        if (itemKey === 'age') {
          tableStructureCopy[index].options = AgeOption.query().get()
        }
        if (itemKey === 'anesthesia-type') {
          const gIndex = tableStructureCopy[index].options.findIndex(
            item => item.value === 'general'
          )
          tableStructureCopy[index].options.splice(gIndex, 1)
          generalAnesthesiaComponentCopy.options.forEach((element, i) => {
            const newObj = Object.assign({}, element)
            newObj.parentName = 'Geral'
            newObj.parentComponent = 'anesthesia-type'
            tableStructureCopy[index].options.splice(gIndex + i, 0, newObj)
          })

          const cIndex = tableStructureCopy[index].options.findIndex(
            item => item.value === 'loco-regional'
          )
          tableStructureCopy[index].options.splice(cIndex, 1)
          locoRegionalTreeCopy.locoRegionalTree.forEach((element, i) => {
            const newObj = Object.assign({}, element)
            newObj['text'] = newObj['name']
            delete newObj['name']
            newObj.parentName = 'Regional'
            newObj.component = 'loco-regional-anesthesia'
            newObj.parentComponent = 'anesthesia-type'
            tableStructureCopy[index].options.splice(cIndex + i, 0, newObj)
          })
        }
      })

      return tableStructureCopy.map((item, index) => {
        item.options = item.options.filter(option =>
          this.logs.some(log => {
            return log[option.component] == option.value
          })
        )
        return item
      })
    },
    tableSubItems() {
      let items = []
      this.tableItems.forEach(item => {
        items = [...items, ...item.options]
      })
      return items
    },
    tableValues() {
      const motive = this.components.find(
        item => item.uid === 'specialty.intervention-motive'
      )
      const procedure = this.components.find(
        item => item.uid === 'specialty.surgical-procedure'
      )
      const rows = []
      if(motive && motive.id) {
        this.logs.forEach(log => {
          if (log[motive.id] && log[motive.id].length > 0) {
            let motiveTitle = ''
            let procedureTitle = ''
            if (Array.isArray(log[motive.id]) && log[motive.id].length > 0) {
              motiveTitle = log[motive.id].join(' + ')
            }
            if (!Array.isArray(log[motive.id])) {
              log[motive.id].split().join(' + ')
            }
            if (
              Array.isArray(log[procedure.id]) &&
              log[procedure.id].length > 0
            ) {
              procedureTitle = log[procedure.id].join(' + ')
            }
            if (log[procedure.id] && !Array.isArray(log[procedure.id])) {
              procedureTitle = log[procedure.id].split().join(' + ')
            }
            if (!rows.some(e => e.rowTitle === motiveTitle)) {
              rows.push({
                rowTitle: motiveTitle,
                rowData: [
                  {
                    title: procedureTitle,
                    items: this.getValues(procedure, log[procedure.id])
                  }
                ]
              })
            } else {
              const rowIndex = rows.findIndex(e => e.rowTitle === motiveTitle)
              if (!rows[rowIndex].rowData.some(e => e.title === procedureTitle)) {
                rows[rowIndex].rowData = [
                  ...rows[rowIndex].rowData,
                  {
                    title: procedureTitle,
                    items: this.getValues(procedure, log[procedure.id])
                  }
                ]
              }
            }
          }
        })
      }
      return rows
    },
    tableTotals() {
      let totals = []
      this.tableValues.forEach(row => {
        row.rowData.forEach(value => {
          value.items.forEach((value, index) => {
            totals[index] = totals[index]
              ? totals[index] + value.count
              : value.count
          })
        })
      })
      return totals
    },
    tablePercentageTotals() {
      const columns = []
      let groupCount = 0
      this.tableItems.forEach(table => {
        table.options.forEach(column => {
          if (!columns.some(e => e.component === column.component)) {
            groupCount++
          }
          column.group = groupCount
          columns.push(column)
        })
      })
      columns.map((column, index) => (column.count = this.tableTotals[index]))
      let holder = {}

      columns.forEach(d => {
        const itemKey = d.component ? d.component : d.parentComponent
        if (holder.hasOwnProperty(itemKey)) {
          holder[itemKey] = holder[itemKey] + d.count
        } else {
          holder[itemKey] = d.count
        }
      })

      columns.map((column, i) => {
        const holderValue =
          holder[
            columns[i].component
              ? columns[i].component
              : columns[i].parentComponent
          ]
        let totalInPercent =
          columns[i].count === 0 ? 0 : (columns[i].count / holderValue) * 100
        columns[i].percentageTotal =
          totalInPercent === 0 ? 0 : totalInPercent.toFixed(1)
      })
      return columns
    }
  },
  methods: {
    getValues(procedure, procedureValue) {
      const values = []
      let groupCount = 0
      this.tableItems.forEach(table => {
        table.options.forEach(row => {
          let count = 0
          if (row.component !== 'loco-regional-anesthesia') {
            this.logs.forEach(log => {
              if (
                log[row.component] === row.value &&
                log[procedure.id] === procedureValue
              ) {
                count++
              }
            })
          } else {
            if (row.children) {
              row.children.forEach(el => {
                if (el.children) {
                  el.children.forEach(child => {
                    this.logs.forEach(log => {
                      if (
                        log[row.component] &&
                        log[procedure.id] === procedureValue &&
                        log[row.component].includes(child.id)
                      ) {
                        count++
                      }
                    })
                  })
                } else {
                  this.logs.forEach(log => {
                    if (
                      log[row.component] &&
                      log[procedure.id] === procedureValue &&
                      log[row.component].includes(el.id)
                    ) {
                      count++
                    }
                  })
                }
              })
            } else {
              this.logs.forEach(log => {
                if (
                  log[row.component] &&
                  log[procedure.id] === procedureValue &&
                  log[row.component].includes(row.id)
                ) {
                  count++
                }
              })
            }
          }

          // gouping by column
          if (
            !values.some(
              e =>
                e.component === row.component ||
                e.component === row.parentComponent
            )
          ) {
            groupCount++
          }

          values.push({
            count: count,
            component: row.component ? row.component : row.parentComponent,
            group: groupCount
          })
        })
      })
      return values
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style scoped>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table.bordered td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table.bordered tr td,
.styled-table.bordered thead th {
  border-right: 1px solid var(--accent-border-color);
}
.styled-table.bordered tr td:last-child,
.styled-table.bordered thead th:last-child {
  border-right: none;
}
.categ-title {
  background-color: var(--categ-color) !important;
  width: 20px;
  font-weight: bold;
}
.subcateg-title {
  background-color: var(--subcateg-color) !important;
}
.rotate-text {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
}
.combined-report thead th.header-title {
  background-color: var(--categ-color) !important;
}
.combined-report thead th.total {
  background-color: var(--bg-color) !important;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.odd {
  background-color: var(--bg-odd-color);
}
.even {
  background-color: var(--bg-light-color);
}

tr.total td {
  background-color: var(--bg-odd-color);
}
tr.total td.odd {
  background-color: var(--subcateg-color);
}
.styled-table td.total {
  background-color: var(--subcateg-color);
  font-weight: bold;
  min-width: 70px;
}
.total-cell {
  background-color: var(--categ-color) !important;
  font-weight: bold;
}

.styled-table tr:last-of-type {
  border-bottom: 2px solid #009879;
}
</style>
